export const TABS_AND_STATES = {
  members: {
    teamless: null,
    leader: "team members",
    member: "team members",
  },
  received_requests: {
    teamless: "teams invitated you",
    leader: "recieved requests",
    member: null,
  },
  sent_requests: {
    teamless: "team join requests",
    leader: "sent requests",
    member: null,
  },
} as const;

export const TABS_KEYS = Object.keys(TABS_AND_STATES) as (keyof typeof TABS_AND_STATES)[];
